import { useCallback, useEffect, useState } from "react";
import { Snowflake, Ghost, Moon, Egg, Flower2, Heart, Sparkles, Gift, Candy, Rabbit, PartyPopper, Star, Tag, ShoppingBag, Percent, Clover, Leaf } from "lucide-react";
import { API, api } from "@/lib/api";

let cache = null;
const listeners = new Set();
export const loadHoliday = (force) => {
  if (!cache || force) cache = fetch(`${API}/holiday`).then((r) => r.json()).catch(() => ({ skin: null, perks: [], packs: [] }));
  cache.then((d) => listeners.forEach((f) => f(d)));
  return cache;
};

export const useHoliday = () => {
  const [d, setD] = useState({ skin: null, perks: [], packs: [] });
  useEffect(() => {
    listeners.add(setD);
    loadHoliday().then(setD);
    return () => listeners.delete(setD);
  }, []);
  return d;
};

export const useOwnedPacks = () => {
  const [owned, setOwned] = useState([]);
  const refresh = useCallback(() => api.get("/holiday/me").then((r) => setOwned(r.data.owned || [])).catch(() => {}), []);
  useEffect(() => { refresh(); }, [refresh]);
  return [owned, refresh, setOwned];
};

export const Lys = ({ className = "", style }) => (
  <svg viewBox="0 0 24 24" className={className} style={style} fill="currentColor" aria-hidden="true">
    <path d="M12 2c1.6 2 2.4 3.9 2.4 5.8 0 1.6-.8 3.2-2.4 4.6-1.6-1.4-2.4-3-2.4-4.6C9.6 5.9 10.4 4 12 2Zm-3.6 6.4c-2.1-.4-3.9.3-4.6 1.9-.7 1.8.4 3.6 2.4 3.7H11c-.9-1-1.4-1.9-1.5-2.9-.1-1.1-.5-2-1.1-2.7Zm7.2 0c-.6.7-1 1.6-1.1 2.7-.1 1-.6 1.9-1.5 2.9h4.8c2 0 3.1-1.9 2.4-3.7-.7-1.6-2.5-2.3-4.6-1.9ZM7 15.2h10v1.6H7v-1.6Zm3.9 2.4h2.2l.6 4.4h-3.4l.6-4.4Z" />
  </svg>
);

export const DECO_ICONS = {
  snow: [Snowflake, Snowflake, Gift],
  bats: [Ghost, Moon, Candy],
  eggs: [Egg, Flower2, Rabbit],
  hearts: [Heart, Heart, Sparkles],
  lys: [Lys, Lys, PartyPopper],
  confetti: [PartyPopper, Sparkles, Star],
  tags: [Tag, ShoppingBag, Percent],
  clover: [Clover, Clover, Sparkles],
  maple: [Leaf, Leaf, Star],
};
